<template>
  <div class="user" >
    <el-row class="m-con">
      <el-col class="user-list" :span="4">
        <el-input size="small" placeholder="请输入用户名称" suffix-icon="el-icon-search" v-model="search">
        </el-input>
        <el-select size="small" filterable @clear="gethuanyuan()" v-model="saveData.branch_id" placeholder="请选择" clearable
          @change="handleAreaChange(saveData.branch_id)" style="margin-top: 5px;">
          <el-option v-for="reg in branch" :key="reg.id" :label="reg.name" :value="reg.id"></el-option>
        </el-select>
        <div class="list">
          <div class="pb15" :class="{ 'active-user': active_user === item.id }" v-for="(item, index) in filterUsers"
            :key="index">
            <i class="el-icon-user"></i>
            <span class="sel-user" @click="selectUser(index, item)">{{
              item.username
            }}</span>
            <el-dropdown trigger="click" @command="handleCommand" class="more-icon">
              <span class="el-dropdown-link"><i class="el-icon-s-fold"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ action: 'bind', index: index, id: item.id }">绑定微信</el-dropdown-item>
                <el-dropdown-item :command="{ action: 'contract', index: index, id: item.id }">发起合同</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-col>
      <el-col :span="20">
        <div class="role-header">
          <i class="el-icon-edit"></i>
          <span>配置角色</span>
          <el-row>
            <el-col :span="6">
              <el-button type="primary" size="mini" @click="handleAddOpen">添加用户</el-button>
              <a href="/setting_panel">
                <el-button type="primary" size="mini">返回上一级</el-button>
              </a>
            </el-col>
            <el-col :span="2" :offset="15">
              <el-popover placement="left-start" width="400" trigger="click">
                <el-form :model="belongToCompanyForm" ref="belongToCompanyForm" label-width="0px">
                  <el-form-item label="" prop="">
                    <el-select style="width:100%" size="mini" v-model="belongToCompanyForm.belong_to_company" placeholder="请选择所属公司"
                      filterable clearable multiple>
                      <el-option label="上海优开信息科技有限公司" :value="1"></el-option>
                      <el-option label="上海账六六信息科技有限公司" :value="2"></el-option>
                      <el-option label="云上飕飕（上海）企业管理有限公司" :value="3"></el-option>
                      <el-option label="鑫项云企业服务（上海）有限公司" :value="4"></el-option>
                      <el-option label="优开财务顾问（上海）有限公司" :value="5"></el-option>
                      <el-option label="畅享无忧财务顾问（上海）有限公司" :value="6"></el-option>
                    </el-select>
                    <i class="el-icon-s-opportunity" style="color:#E6A23C;font-size:x-small"> 不选择默认导出全部</i>
                  </el-form-item>
                  <el-form-item label="" prop="" style="text-align: right">
                    <el-button type="primary" size="mini" @click="exportUserInfo">导出</el-button>
                  </el-form-item>
                </el-form>
                <el-tag slot="reference" type="primary" size="medium" effect="dark" style="cursor: pointer;">导出用户信息</el-tag>
              </el-popover>
            </el-col>
          </el-row>
          <div>|&nbsp;&nbsp;总人数：{{ statistical.count }} &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;无头像：{{ statistical.user_img }}
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;离职：{{ statistical.in_service }}
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;禁用：{{ statistical.status }} &nbsp;&nbsp;&nbsp;|</div>
        </div>
        <div v-if="!active_user" class="role-empty">
          <p>暂无数据</p>
        </div>
        <div class="role-con" v-else>
          <!-- @tab-click="handle_chooseUserType" -->
          <el-tabs type="border-card" style="margin-top: 0.2rem" v-model="userManage">
            <el-tab-pane label="配置角色" name="1">
              <!-- <el-collapse v-model="activeName" accordion>
                <el-collapse-item name="1"> -->
              <template slot="title">
                <span class="check-title">角色</span>
                <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              </template>
              <el-checkbox-group size="small" v-model="checkedRoles" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="role in roles" :label="role.id" :key="role.id" border>{{ role.role_name }}
                </el-checkbox>
              </el-checkbox-group>
              <el-row class="tr mt10">
                <el-button type="primary" size="mini" @click="handleSaveRole">保存角色设置</el-button>
              </el-row>
              <!-- </el-collapse-item> -->
              <!-- <el-collapse-item name="2"> -->
            </el-tab-pane>
            <el-tab-pane label="用户信息" name="2">
              <template slot="title">
                <span class="check-title">配置用户信息</span>
              </template>
              <el-row>
                <span class="check-title">头像（请上传正方形图片）</span>
                <el-upload class="avatar-uploader" :action="actionHost + '/api/upload/users/portrait'"
                  accept="image/jpeg,image/png,image/jpg" :headers="uploadHeader" :show-file-list="false"
                  :on-success="handleEditPortraitSuccess" :before-upload="beforeAvatarUpload">
                  <img v-if="saveData.buphoto" :src="saveData.buphoto" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="demo-image">
                  <span class="check-title">我的企业微信二维码</span>
                  <span class="dian_button" @click="my_qyh_qywx">
                    <el-image v-if="saveData.qyh_qywx" style="width: 3rem; height: 3rem"
                      :src="saveData.qyh_qywx"></el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </span>
                </div>
                <div class="demo-image">
                  <span class="check-title">企业火推广人数：{{ qyhRenCount }}</span>
                  <span class="dian_button" @click="my_qyh_user">
                    <el-image v-if="saveData.qyh_code" style="width: 3rem; height: 3rem"
                      :src="saveData.qyh_code"></el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </span>
                </div>
                <div class="demo-image">
                  <span class="check-title">税筹园推广人数：{{ taxRenCount }}</span>
                  <span class="dian_button" @click="my_tax_code">
                    <el-image v-if="saveData.tax_code" style="width: 3rem; height: 3rem" :src="saveData.tax_code">
                    </el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </span>
                </div>
                <div class="demo-image">
                  <span class="check-title">开业盒子推广人数：{{ boxRenCount }}</span>
                  <span class="dian_button" @click="my_box_code">
                    <el-image v-if="saveData.box_code" style="width: 3rem; height: 3rem" :src="saveData.box_code">
                    </el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </span>
                </div>
              </el-row>
              <el-divider></el-divider>
              <div style="margin: 20px 0;">
                <el-row>
                  <el-col :span="12">
                    <dd-qrcode-login :user="selUserInfo" bindState="qyh_bind"></dd-qrcode-login>
                  </el-col>
                  <el-col :span="12">
                    <qw-qrcode-login :user="selUserInfo" @updateUser="updateUser"></qw-qrcode-login>
                  </el-col>
                </el-row>
              </div>
              <el-form class="profile">
                <el-form-item label="姓名：">
                  <el-input placeholder="请输入姓名" v-model="saveData.username" type="string" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="密码：">
                  <el-input placeholder="请输入新密码" v-model="saveData.password" type="string" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="性别" prop="region">
                  <el-select v-model="saveData.sex" placeholder="请选择性别">
                    <el-option label="男" :value="1"></el-option>
                    <el-option label="女" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="region">
                  <el-select v-model="saveData.status" placeholder="请选择状态">
                    <el-option label="启用" :value="1"></el-option>
                    <el-option label="禁用" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="在职状态" prop="region">
                  <el-select v-model="saveData.in_service" placeholder="请选择状态">
                    <el-option label="在职" :value="1"></el-option>
                    <el-option label="离职" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                  <el-input v-model="saveData.phone" autoComplete="new-phone"></el-input>
                </el-form-item>
                <el-form-item label="部门" prop="branch_id">
                  <el-select filterable v-model="saveData.branch_id" placeholder="请选择" clearable>
                    <el-option v-for="reg in branch" :key="reg.id" :label="reg.name" :value="reg.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="公司分区" prop="company_part">
                  <el-select filterable v-model="saveData.company_part" placeholder="请选择" clearable>
                    <el-option label="奉贤" :value="1"></el-option>
                    <el-option label="静安" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="业务级别" prop="user_level">
                  <el-select v-model="saveData.user_level" placeholder="请选择业务级别">
                    <el-option label="A" :value="1"></el-option>
                    <el-option label="B" :value="2"></el-option>
                    <el-option label="C" :value="3"></el-option>
                    <el-option label="D" :value="4"></el-option>
                    <el-option label="E" :value="5"></el-option>
                    <el-option label="Z" :value="26"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="idCard" prop="id_card">
                  <el-input v-model="saveData.id_card" autoComplete="new-id_card"></el-input>
                </el-form-item>
                <el-form-item label="职位：">
                  <el-input placeholder="请输入职位" v-model="saveData.position" type="string" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="固定电话：">
                  <el-input placeholder="请输入固定电话" v-model="saveData.fixed_telephone" type="string" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="邮箱：">
                  <el-input placeholder="请输入邮箱" v-model="saveData.email" type="string" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="微信号：">
                  <el-input placeholder="请输入微信号" v-model="saveData.wx_num" type="string" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="客服通道：">
                  <el-input placeholder="请输客服通道" v-model="saveData.customer_service" type="string" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="擅长领域：">
                  <span style="color:red;font-size:12px;"> * 注： 多个擅长领域时 必须以 ' 空格 ' 分割</span>
                  <el-input placeholder="请输入擅长领域" v-model="saveData.areas_of_expertise" type="textarea" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="个人标签：">
                  <el-input placeholder="请输入个人标签" v-model="saveData.personal_label" type="textarea" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="个人简介：">
                  <el-input placeholder="请输入个人简介" v-model="saveData.personal_profile" type="textarea" clearable>
                  </el-input>
                </el-form-item>
                <el-form-item label="坐席号码：">
                  <i class="el-icon-warning" style="color: #e6a23c; font-size: 0.2rem">坐席号码或坐席手机号重新分配，原有的绑定人员会解除绑定！</i>
                  <el-select v-model="saveData.seat_number" placeholder="暂无坐席号码，点击选择！" clearable filterable size="medium"
                    style="width: 100%" @click.native="getSeatPhone_r(1)">
                    <el-option v-for="(item, index) in seatNumberOptions" :key="index" :label="item.seat"
                      :value="item.seat_v">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="坐席手机号：">
                  <i class="el-icon-warning" style="color: #e6a23c; font-size: 0.2rem">先选择坐席号码！</i>
                  <el-select ref="configSelect" v-model="saveData.seat_phone" placeholder="暂无坐席手机号，点击选择！" clearable
                    filterable size="medium" style="width: 100%" @click.native="getSeatPhone">
                    <!-- @change="changeSeatPhone" -->
                    <el-option v-for="(item, index) in seatPhoneOptions" :key="index" :label="item.phone"
                      :value="item.phone_v">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="地址：">
                  <i class="el-icon-warning" style="color: #e6a23c; font-size: 0.2rem">主要用于接收客户快递！</i>
                  <el-tooltip :content="saveData.address" effect="dark" placement="top">
                    <div id="autocomplete">
                      <el-autocomplete ref="ysy_autocomplete" placeholder="收件地址" v-model="saveData.address" type="text"
                        clearable :maxlength="100" show-word-limit style="width: 100%;" :fetch-suggestions="querySearch"
                        @clear="ysyblur" @select="handleSelect">
                        >
                        <i class="el-icon-edit el-input__icon" slot="suffix">
                        </i>
                        <template slot-scope="{item}">
                          <div :title="item.value" class="name" style="text-overflow: ellipsis;overflow: hidden;">{{
                            item.value }}</div>
                          <el-tooltip :content="item.address" effect="dark" placement="top">
                            <div class="addr" style="font-size: 12px;color: #b4b4b4;">{{ item.address }}</div>
                          </el-tooltip>
                        </template>
                      </el-autocomplete>
                    </div>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="入职时间">
                  <el-date-picker v-model="saveData.regtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择入职日期" style="width:100%">
                  </el-date-picker>
                </el-form-item>
                <el-row class="tr mt10 mt100">
                  <el-button type="primary" size="mini" @click="handleSaveUSer">保存配置用户信息</el-button>
                </el-row>
              </el-form>
              <!-- </el-collapse-item> -->
              <!-- </el-collapse> -->
            </el-tab-pane>
            <el-tab-pane label="角色管理" name="3">
              ok
            </el-tab-pane>
            <el-tab-pane label="人员信息" name="4">
              <salary-info :adminuser_id="comAdminUserId" :adminuser_name="comAdminUserName" :b_company="bCompanyname"/>
              <!-- <int-per/> -->
            </el-tab-pane>
            <el-tab-pane label="人员信息new" name="5">
              <int-per :adminuser_id="comAdminUserId" :adminuser_name="comAdminUserName"/>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
    <!-- </el-collapse-item>
      </el-collapse>
      </el-col>
      </el-row> -->
    <el-dialog title="绑定微信" :visible.sync="bindDialogVisible" width="40%" :before-close="handleBindClose">
      <el-select v-model="wxUserID" placeholder="请选择" size="mini" filterable>
        <el-option v-for="(user, index) in wxUsers" :key="index" :label="user.user_nickname" :value="user.user_id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleBindSub">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="添加用户" :visible.sync="drawer" direction="rtl" :before-close="handleAddClose" size="40%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-form">
        <div style="padding-right: 3em">
          <el-form-item label="姓名" prop="nickname">
            <el-input v-model="form.nickname" autoComplete="new-nickname"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="form.password" autoComplete="new-password"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="region">
            <!-- <el-select v-model="form.sex" placeholder="请选择性别">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="0"></el-option>
            </el-select> -->
            <el-radio-group v-model="form.sex">
              <el-radio-button :label="0">女</el-radio-button>
              <el-radio-button :label="1">男</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="状态" prop="region">
            <!-- <el-select v-model="form.status" placeholder="请选择状态">
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select> -->
            <el-radio-group v-model="form.status">
              <el-radio-button :label="0">禁用</el-radio-button>
              <el-radio-button :label="1">启用</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" autoComplete="new-phone"></el-input>
          </el-form-item>
          <!-- <el-form-item label="所属公司" prop="belongToComopany">
            <el-select v-model="form.belongToComopany" placeholder="请选择所属公司">
              <el-option label="上海优开信息科技有限公司" value="1"></el-option>
              <el-option label="上海账六六信息科技有限公司" value="2"></el-option>
              <el-option label="云上飕飕（上海）企业管理有限公司" value="3"></el-option>
              <el-option label="鑫项云企业服务（上海）有限公司" value="4"></el-option>
              <el-option label="优开财务顾问（上海）有限公" value="5"></el-option>
              <el-option label="畅享无忧财务顾问（上海）有限公司" value="6"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="部门" prop="branch_id">
            <el-select v-model="form.branch_id" placeholder="请选择" filterable  clearable>
              <!-- @change="handelOrderRegTypeSel('order_reg_type', '订单类型', 'saveForm')" -->
              <el-option v-for="reg in branch" :key="reg.id" :label="reg.name" :value="reg.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司分区" prop="company_part">
            <!-- <el-select v-model="form.company_part" placeholder="请选择公司分区">
              <el-option label="奉贤" value="1"></el-option>
              <el-option label="静安" value="2"></el-option>
            </el-select> -->
            <el-radio-group v-model="form.company_part">
              <el-radio-button :label="1">奉贤</el-radio-button>
              <el-radio-button :label="2">静安</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="业务级别" prop="user_level">
            <el-select v-model="form.user_level" placeholder="请选择业务级别">
              <el-option label="A" value="1"></el-option>
              <el-option label="B" value="2"></el-option>
              <el-option label="C" value="3"></el-option>
              <el-option label="D" value="4"></el-option>
              <el-option label="E" value="5"></el-option>
              <el-option label="Z" value="26"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="idCard" prop="id_card">
            <el-input v-model="form.id_card" autoComplete="new-id_card"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>
    <el-drawer title="合同" :visible.sync="contractDrawer" direction="rtl" :before-close="handleContractClose" size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form :model="contractForm" ref="contractForm" label-width="100px" size="mini">
          <el-form-item label="我方企业" prop="tx_company_id">
            <el-select v-model="contractForm.tx_company_id" filterable placeholder="请输入公司名称筛选公司" size="mini" clearable
              @change="handleTxCompanyChange">
              <el-option v-for="company in txElectronicCompanies" :key="company.id" :label="company.organization_name"
                :value="company.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同模板">
            <span style="display: inline-block; position: relative; bottom: 4px">{{ contractForm.template_name }}</span>
            <el-tooltip class="item" effect="dark" content="选择合同模板" placement="top">
              <i class="el-icon-zoom-in" style="font-size: 0.5rem; color: #409eff; cursor: pointer"
                @click="handleOpenTemplate"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item :label="control.componentName" v-for="control in contractForm.controls"
            :key="control.componentId">
            <el-input v-if="control.componentType === 'TEXT' &&
              control.componentName === '合同费用'
              " v-model="control.componentValue" @change="handleConvert"></el-input>
            <el-input v-else-if="control.componentType === 'TEXT'" v-model="control.componentValue"></el-input>
            <el-input v-else-if="control.componentType === 'MULTI_LINE_TEXT'" type="textarea"
              v-model="control.componentValue">
            </el-input>
          </el-form-item>
        </el-form>
        <el-row style="padding-top: 0.4rem; padding-bottom: 2rem; float: right">
          <el-col>
            <el-button type="primary" size="mini" @click="submitContractForm('contractForm')">发起合同</el-button>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog title="选择模板" :visible.sync="templateVisible">
      <el-table :data="templates" size="mini" border style="width: 100%; margin-top: 0.2rem" v-cloak>
        <el-table-column fixed label="模板名称" width="240px">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.name" placement="top">
              <span class="hide-style" style="color: #409eff; cursor: pointer"
                @click="handleDescribeOpen(scope.row.describe)">{{ scope.row.name }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="模板类型" prop="template_type"></el-table-column>
        <el-table-column label="静默签署" prop="is_silence"></el-table-column>
        <el-table-column label="创建人" prop="founder"></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleTemplateSel(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
        :current-page="tplPageOption.currentPage" :page-size="tplPageOption.pageSize" :total="tplPageOption.total"
        @current-change="handleTplCurrentChange">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
// import ret from 'bluebird/js/release/util'
import SalaryInfo from './SalaryInfo'
import IntPer from './IntelligentPersonnel'
import DdQrcodeLogin from '@/pages/authority/common/DdQrcodeLogin'
import QwQrcodeLogin from '@/pages/authority/common/QwQrcodeLogin'
export default {
  name: 'User',
  components: { SalaryInfo, IntPer, DdQrcodeLogin, QwQrcodeLogin },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value !== '') {
        var reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输⼊有效的⼿机号码'))
        }
      }
      callback()
    }
    return {
      belongToCompanyForm: {
        belong_to_companyForm: ''
      },
      form: {
        nickname: '',
        password: '',
        sex: '1',
        status: '1',
        phone: '',
        branch_id: '',
        company_part: '1',
        user_level: '26',
        id_card: '',
      },
      comAdminUserId: null,
      comAdminUserName: null,
      bCompanyname: null,
      userManage: '1',
      drawer: false,
      activeName: '1',
      search: '',
      active_user: null,
      users: [],
      branch: [],
      statistical: [],
      roles: [],
      checkAll: false,
      checkedRoles: [],
      bindDialogVisible: false,
      wxUserID: null,
      userId: null,
      wxUsers: [],
      direction: 'rtl',
      editDrawer: false,
      uploadHeader: { Authorization: localStorage.token },
      seatNumberOptions: [],
      al_seatNumberOptions: [
        '8808220954089435',
        '8806091366936748',
        '8811111058647942',
        '8811111052246186',
        '8811091604746036',
        '8811091614722508',
        '8811091604948088',
        '8811091654698636',
        '8811051591685042',
        '8810191431937663'
      ],
      seatPhoneOptions: [],
      // al_seatPhoneOptions: [
      //   '15921375408',
      //   '15900786693',
      //   '13524734827',
      //   '13646033193',
      //   '13817290474',
      //   '13817411472',
      //   '13817370494',
      //   '15221005469',
      //   '15921248357',
      //   '13564059168'
      // ],
      al_seatPhoneOptions: [],
      afterSubmitRow: '',
      beginSeatPhone: false,
      historySeatPhone: '',
      againDisName: '',
      restaurants: [],
      saveData: {
        id: null,
        address_value: '',
        address: '',
        username: '',
        sex: '',
        status: '',
        in_service: '',
        phone: '',
        branch_id: '',
        company_part: '',
        user_level: '',
        id_card: '',
        password: '',
        buphoto: '',
        hid_buphoto: '',
        position: '',
        fixed_telephone: '',
        email: '',
        wx_num: '',
        customer_service: '',
        areas_of_expertise: '',
        personal_label: '',
        personal_profile: '',
        tax_code: '',
        hid_tax_code: '',
        box_code: '',
        hid_box_code: '',
        qyh_code: '',
        hid_qyh_code: '',
        seat_number: '',
        seat_phone: '',
        regtime: '',
        qyh_qywx: '',
        // belong_to_company: ''
      },
      qyhRenCount: '',
      taxRenCount: '',
      boxRenCount: '',
      rules: {
        nickname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' }
        ],
        branch_id: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ]
      },
      contractDrawer: false,
      txElectronicCompanies: [],
      contractForm: {
        admin_id: null,
        tx_company_id: '',
        type: '个人',
        template_id: '',
        template_name: '',
        controls: [],
      },
      tplSearchArr: {
        template_type: '个人',
        is_silence: '否',
      },
      tplPageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条数
      },
      templateVisible: false,
      templates: [],
      selUserInfo: null
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      }
    },
    filterUsers: {
      get: function () {
        return this.users.filter(
          data =>
            !this.search ||
            data.username.toLowerCase().includes(this.search.toLowerCase())
        )
      }
    },
    collapse() {
      return this.$store.state.collapse
    },
    tplSearchStr: function () {
      let str = ''
      for (let key in this.tplSearchArr) {
        str += '&' + key + '=' + this.tplSearchArr[key]
      }
      return str
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    loadAll() {
      return [
        { "value": "奉贤", "address": "南桥镇望园南路1288号上海南桥中小企业总部商务区五号楼7楼" },
        { "value": "静安", "address": "武宁南路488号智慧广场801" }
      ];
    },
    ysyblur() {
      document.activeElement.blur()
      this.saveData.address_value = ''
    },
    handleSelect(val) {
      this.saveData.address_value = val.address
    },
    gethuanyuan() {
      this.getUser()
    },
    handleAreaChange(compID) {
      this.$axios.get('/api/admin/usersearch/' + compID).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.users = data.data.users
        }
      })
    },
    getSeatPhone_r(type) {
      setTimeout(() => {
        this.$axios
          .get('api/admin/user/get_seat_api')
          .then(({ data }) => {
            if (data.code === 1) {
              this.seatNumberOptions = data.data
              this.al_seatPhoneOptions = data.phone
            }
          })
          .catch()
      }, 200)
    },
    changeSeatPhone(val) {
      this.$axios
        .get('api/admin/user/seat_phone_if_dis?seatPhone=' + val)
        .then(({ data }) => {
          if (data.code === 1) {
            this.$confirm(data.msg + '【' + this.againDisName + '】吗？')
              .then(_ => {
                this.$refs.configSelect.blur()
              })
              .catch(_ => {
                this.saveData.seat_phone = this.historySeatPhone
                this.$refs.configSelect.blur()
              })
          } else {
            this.$refs.configSelect.blur()
          }
        })
        .catch()
    },
    getSeatPhone() {
      if (this.beginSeatPhone) {
        this.historySeatPhone = this.saveData.seat_phone
        var newDisArr = this.al_seatPhoneOptions.filter(item => {
          return item !== this.historySeatPhone
        })
        this.seatPhoneOptions = newDisArr
        return false
      }
      this.seatPhoneOptions = this.al_seatPhoneOptions
    },
    getSeatNumber() {
      this.seatNumberOptions = this.al_seatNumberOptions
    },
    getUser() {
      this.$axios.get('/api/admin/users').then(res => {
        const { data } = res
        if (data.code === 0) {
          this.users = data.data.users
          this.roles = data.data.roles
          this.branch = data.data.branch
          this.statistical = data.data.statistical
        }
      })
    },
    selectUser(index, row) {
      this.comAdminUserId = null
      this.$nextTick(_=>{
        this.comAdminUserId = row.id
      })
      this.comAdminUserName = row.username
      this.afterSubmitRow = row
      this.saveData.address = ''
      this.saveData.address_value = ''
      this.saveData.password = ''
      this.bCompanyname = null
      this.$axios.get('/api/admin/user/roles/' + row.id).then(res => {
        const { data } = res
        if (data.code === 0) {
          this.secondId = ''
          this.checkedRoles = data.data.roles
          this.qyhRenCount = data.data.qyhRenCount
          this.taxRenCount = data.data.taxRenCount
          this.boxRenCount = data.data.boxRenCount
          this.selUserInfo = data.data.adminUserInfo
          this.saveData.hid_buphoto = data.data.adminUserInfo.buphoto
          this.saveData.buphoto = data.data.adminUserInfo.hid_buphoto
          this.saveData.position = data.data.adminUserInfo.position
          this.saveData.fixed_telephone = data.data.adminUserInfo.fixed_telephone
          this.saveData.email = data.data.adminUserInfo.email
          this.saveData.wx_num = data.data.adminUserInfo.wx_num
          this.saveData.customer_service = data.data.adminUserInfo.customer_service
          this.saveData.areas_of_expertise = data.data.adminUserInfo.areas_of_expertise
          this.saveData.personal_label = data.data.adminUserInfo.personal_label
          this.saveData.personal_profile = data.data.adminUserInfo.personal_profile
          this.saveData.qyh_code = data.data.adminUserInfo.hid_qyh_code
          this.saveData.hid_qyh_code = data.data.adminUserInfo.qyh_code
          this.saveData.tax_code = data.data.adminUserInfo.hid_tax_code
          this.saveData.hid_tax_code = data.data.adminUserInfo.tax_code
          this.saveData.box_code = data.data.adminUserInfo.hid_box_code
          this.saveData.hid_box_code = data.data.adminUserInfo.box_code
          this.saveData.qyh_qywx = data.data.adminUserInfo.qyh_qywx
          this.saveData.address = data.data.adminUserInfo.address
          if (this.roles.length > 0) {
            this.checkAll = this.checkedRoles.length === this.roles.length
          }
          this.active_user = row.id
          this.saveData.id = row.id
          this.saveData.seat_number = data.data.adminUserInfo.seat_number
          this.saveData.seat_phone = data.data.adminUserInfo.seat_phone
          if (this.saveData.seat_phone) this.beginSeatPhone = true
          this.againDisName = data.data.adminUserInfo.username
          this.saveData.username = data.data.adminUserInfo.username
          this.saveData.sex = data.data.adminUserInfo.sex
          this.saveData.status = data.data.adminUserInfo.status
          this.saveData.in_service = data.data.adminUserInfo.in_service
          this.saveData.phone = data.data.adminUserInfo.phone
          this.saveData.branch_id = data.data.adminUserInfo.branch_id
          this.saveData.company_part = data.data.adminUserInfo.company_part
          this.saveData.user_level = data.data.adminUserInfo.user_level
          this.saveData.id_card = data.data.adminUserInfo.id_card
          this.saveData.regtime = data.data.adminUserInfo.regtime
          // this.saveData.belong_to_company = data.data.adminUserInfo.belong_to_company
          this.bCompanyname = data.data.adminUserInfo.belong_to_company
        }
      })
    },
    handleCheckAllChange(val) {
      this.checkedRoles = val ? this.getCheckedArr() : []
    },
    getCheckedArr() {
      let arr = []
      for (var i = 0; i < this.roles.length; i++) {
        arr.push(this.roles[i].id)
      }
      return arr
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.roles.length
    },
    handleSaveUSer() {
      this.$axios
        .put('/api/admin/user/userinformation/' + this.active_user, {
          userInfo: this.saveData
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            if (this.afterSubmitRow) {
              this.selectUser('', this.afterSubmitRow)
            }
            this.afterSubmitRow = ''
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSaveRole() {
      this.$axios
        .put('/api/admin/user/roles/' + this.active_user, {
          checkedRoles: this.checkedRoles
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleCommand(command) {
      if (command.action === 'bind') {
        this.handleBindWxUser(command.index, command.id)
      } else if (command.action === 'contract') {
        this.$axios.get('/api/admin/tx_electronic_companies').then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.txElectronicCompanies = data.data
            this.contractForm.admin_id = command.id
            this.contractDrawer = true
          }
        })
      }
    },
    handleBindWxUser(index, id) {
      this.$axios.get('/api/admin/chat/users/' + id).then(res => {
        let { data } = res
        if (data.code === 0) {
          this.wxUsers = data.data.chatUsers
          this.wxUserID = data.data.bindUser
          this.userId = id
          this.bindDialogVisible = true
        }
      })
    },
    handleBindClose(done) {
      this.wxUserID = null
      this.userId = null
      done()
    },
    handleBindSub() {
      if (!this.wxUserID) {
        this.$message.error('请选择微信昵称')
      }
      this.$axios
        .post('/api/admin/users/wx/bind', {
          wxUserID: this.wxUserID,
          user: this.userId
        })
        .then(res => {
          let { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.wxUserID = null
            this.userId = null
            this.bindDialogVisible = false
          }
        })
    },
    beforeAvatarUpload(file) {
      if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'image/jpg'
      ) {
        this.$message.error('头像只能是 JPEG、JPG、PNG 格式!')
        return false
      }
      return true
    },
    handleEditPortraitSuccess(res, file) {
      if (res.code === 0) {
        this.saveData.buphoto = res.data.signedUrl
        this.saveData.hid_buphoto = res.data.buphoto
      } else {
        this.$message.error(res.msg)
      }
    },
    my_qyh_user() {
      this.$axios
        .put('/api/admin/user/my_qyh_user/' + this.active_user)
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.saveData.hid_qyh_code = data.data.qyh_code
            this.saveData.qyh_code = data.data.hid_qyh_code
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    my_tax_code() {
      this.$axios
        .put('/api/admin/user/my_tax_code/' + this.active_user)
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.saveData.hid_tax_code = data.data.tax_code
            this.saveData.tax_code = data.data.hid_tax_code
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    my_box_code() {
      this.$axios
        .put('/api/admin/user/my_box_code/' + this.active_user)
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.saveData.hid_box_code = data.data.box_code
            this.saveData.box_code = data.data.hid_box_code
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    my_qyh_qywx() {
      this.$axios
        .put('/api/admin/user/my_qyh_qywx/' + this.active_user)
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.saveData.qyh_qywx = data.data.qyh_qywx
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleAddClose(done) {
      this.clearAddData()
      done()
    },
    clearAddData() {
      this.form.nickname = ''
      this.form.password = ''
      this.form.phone = ''
      this.form.branch_id = ''
      // this.$nextTick(() => {
      //   this.$refs.form.clearValidate()
      // })
    },
    handleAddOpen() {
      this.drawer = true
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('/api/admin/users/addusers', {
              data: this.form
            })
            .then(res => {
              if (res.data.code === 0) {
                this.$message.success('恭喜你' + res.data.msg)
                this.$router.go(0)
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {
              this.$message.error('保存失败')
            })
        } else {
          return false
        }
      })
    },
    handleContractClose(done) {
      this.clearContractForm()
      done()
    },
    handleTxCompanyChange(val) {
      this.contractForm.controls = []
      this.contractForm.template_id = ''
      this.contractForm.template_name = ''
      this.showImages = []
      if (val === 1) {
        this.tplSearchArr.is_silence = '是'
      } else {
        this.tplSearchArr.is_silence = '否'
      }
    },
    handleOpenTemplate() {
      if (!this.contractForm.tx_company_id) {
        this.$message.error('请先选择我方企业')
        return
      }
      this.tplSearchArr.template_type = this.contractForm.type
      this.$axios
        .get(
          '/api/admin/qz_electronic_contract_templates?page=' +
          this.tplPageOption.currentPage +
          this.tplSearchStr
        )
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.templates = data.data.templates.data
            this.tplPageOption.total = data.data.templates.total
            this.templateVisible = true
          }
        })
    },
    handleTplCurrentChange(val) {
      this.tplPageOption.currentPage = val
      this.handleOpenTemplate()
    },
    handleTemplateSel(row) {
      this.contractForm.template_id = row.template_id
      this.contractForm.template_name = row.name
      this.templateVisible = false
      this.tplPageOption.currentPage = 1
      this.tplPageOption.total = 0

      this.contractForm.controls = row.components
    },
    handleConvert(val) {
      val = val.replace(/[^\d.]/g, '')
      val = val.replace(/\.{2,}/g, '.')
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      if (val.indexOf('.') < 0 && val !== '') val = parseFloat(val)
      for (let i = 0; i < this.contractForm.controls.length; i++) {
        if (this.contractForm.controls[i].componentName === '合同费用') {
          this.contractForm.controls[i].componentValue = val
        }
      }
      this.digitUppercase(val)
    },
    submitContractForm(formName) {
      if (!this.contractForm.tx_company_id) {
        this.$message.error('我方企业不能为空')
        return
      }

      if (!this.contractForm.template_id) {
        this.$message.error('合同模板不能为空')
        return
      }

      if (this.contractForm.controls.length > 0) {
        for (let i = 0; i < this.contractForm.controls.length; i++) {
          if (!this.contractForm.controls[i].componentValue) {
            this.$message.error(
              this.contractForm.controls[i].componentName + '不能为空'
            )
            return
          }
        }
      }

      this.$axios
        .post('/api/admin/qz_electronic_contract_controller/palm', this.contractForm)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.contractDrawer = false
            this.clearContractForm()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    clearContractForm() {
      this.contractForm.admin_id = null
      this.contractForm.tx_company_id = ''
      this.contractForm.template_id = ''
      this.contractForm.template_name = ''
      this.contractForm.controls = []
      this.txElectronicCompanies = []
    },
    exportUserInfo() {
      this.$axios.post('api/api3_export_userinfo', this.belongToCompanyForm, { responseType: 'blob' }).then(({ data }) => {
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let objectUrl = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href = objectUrl
        link.download = '人员薪资.xlsx'
        link.click()
        setTimeout(function () {
          window.URL.revokeObjectURL(objectUrl)
        }, 10)
      }).catch()
    },
    updateUser (updatedUser) {
      this.selUserInfo = updatedUser
      this.$emit('updateUser', this.selUserInfo)
    }
  },
  mounted() {
    this.getUser()
    this.clearAddData()
    this.restaurants = this.loadAll()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

.el-checkbox.is-bordered {
  margin-bottom: 0.2rem;
}

.user {
  marginLeft();

  .m-con {
    background-color: #fff;
    border-radius: 0.2rem 0.2rem 0 0;
  }

  .tr {
    text-align: right;
  }

  .mt10 {
    width:100%
    margin-top: 0.2rem;
  }

  .pb15 {
    padding-bottom: 0.3rem;
  }

  .user-list {
    max-height: calc(100vh + 10rem);
    padding-right: 12px;
    border-right: 1px solid #ebebeb;
    overflow-y: auto;

    .list {
      margin-top: 0.3rem;
    }
  }

  .sel-user {
    cursor: pointer;
  }

  .active-user {
    color: #5789f4;
  }

  .role-header {
    line-height: 0.88rem;
    padding-left: 0.4rem;
    margin-bottom: 0.3rem;
    color: #5789F4;
  }

  .role-empty {
    text-align: center;
    color: rgba(0, 0, 0, 0.3);
  }

  .role-con {
    padding-left: 0.4rem;
  }

  .check-title {
    margin-right: 0.4rem;
  }

  .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .more-icon {
    float: right;
    color: #5789F4;
    cursor: pointer;
  }

  .el-select {
    width: 100%;
  }

  .avatar-uploader {
    margin-bottom: 0.2rem;
  }
}

.avatar-uploader >>> .el-upload {
  border: 0.02rem dashed #d9d9d9;
  border-radius: 0.12rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader >>> .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader >>> .el-upload img {
  width: 3rem;
  height: 3rem;
}

.avatar-uploader-icon {
  font-size: 0.4rem;
  color: #8c939d;
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  border: 1px black dotted;
}

.demo-image {
  width: 4rem;
  float: left;
  margin-right: 2%;
}

.el-col-11 {
  padding-top: 0.5rem;
}

.dian_button {
  cursor: pointer;
}
.addUser{
  float: right;
}
.profile .el-form-item {
  margin-bottom: 10px;
  width: 45%;
  float: left;
  margin-right: 20px;
}
.mt100{
  float:right;
  margin-right 4%
  margin-bottom 1%
}
</style>
<style scoped>
#autocomplete>>>input {
  padding-right: 107px !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/authority/User.vue